import { render } from "./PaginationComp.vue?vue&type=template&id=569bd93f&scoped=true"
import script from "./PaginationComp.vue?vue&type=script&lang=js"
export * from "./PaginationComp.vue?vue&type=script&lang=js"

import "./PaginationComp.vue?vue&type=style&index=0&id=569bd93f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569bd93f"]])

export default __exports__